import type { IPaginationProps } from "@magnit/core/src/containers/VPagination/VPagination.types";
import type { IStackItemProps } from "@magnit/core/src/components/VStack/VStack.types";
import type { IBasketAction, IProduct } from "./VProductPreview.types";
import type { ICatalogEmptyProps } from "./VCatalogEmpty.types";

export type IBasketQtyListing = Record<string, number>;
export type IBasketLoadingListing = Record<string, boolean>;

export interface ICatalogListingProps {
  items: IProduct[];
  pagination?: IPaginationProps;
  yaSlotPosition?: number;
  yaSlotDoublePosition?: number;
  loading?: boolean;
  loadingItemsCount?: number;
  emptyUrlPrimaryButton?: string;
  emptyUrlSecondaryButton?: string;
  itemSize?: IStackItemProps["size"];
  catalogEmpty?: ICatalogEmptyProps;
  showRatings?: boolean;

  analyticsSender?: (name: string, params?: Record<string, unknown>) => void;
  analyticsPayload?: Record<string, unknown>;

  theme?: "base" | "V1";
  favoritesAvailable?: boolean;
  favoritesLoading?: Record<string, boolean>;
  ecom?: boolean;
  basketQty?: IBasketQtyListing;
  basketLoading?: IBasketLoadingListing;
}

export type ICatalogListingEmits = {
  "product:click": [product: IProduct];
  "pagination:set-page": [page: number];
  "pagination:show-more": [];
  "modal-adult:approve": [v: boolean];
  "empty:click:primary": [];
  "empty:click:secondary": [];
  "favorite:set": [id: string, flag: boolean];
  "rating:click": [id: string];
  basket: [id: string, step: number, action: IBasketAction];
};

export enum IPromoProductProgressiveDiscountType {
  CASHBACK = "cashback",
  PERCENT = "percent",
  PRICE = "price",
  MAGNETS = "magnets",
  BONUSES = "bonuses",
}

export interface IPromoProductProgressiveDiscountValue {
  count: number;
  label?: string;
  countLabel: string;
  value: number;
}
export interface IPromoProduct {
  alcohol?: boolean;
  articleCategory?: string;
  barcode?: string;
  categoryName?: string;
  categorySlug: string;
  crmCode?: string;
  description?: string;
  discountCategory?: string;
  discountLabel?: string;
  discountPercentage?: number;
  discountShopImage?: string;
  discountType?: string;
  discountValue?: number;
  endDate?: string; // "2024-01-01"
  erid?: string;
  eridInfo?: string;
  id: string;
  image?: string;
  imageUrl?: string;
  imageWeb?: string;
  imageWebUrl?: string;
  name?: string;
  url: string;
  oldPrice?: number;
  previewDiscountTitle?: string;
  price?: number;
  priority?: number;
  productCode: string;
  ratings?: ICatalogBFFRatings;
  progressiveDiscount?: IPromoProductProgressiveDiscountValue[];
  progressiveDiscountType?: IPromoProductProgressiveDiscountType;
  publisher?: string;
  showDate?: string;
  slug: string;
  startDate?: string; // "2024-01-01"
  type?: string;
  unit?: string;
  unit1?: string;
}

export interface ICatalogBFFBadge {
  backgroundColor: string;
  text: string;
  textColor: string;
}

export interface ICatalogBFFMedia {
  key?: string;
  type: string;
  url: string;
}

export interface ICatalogBFFPromotion {
  discountPercent?: number;
  endDate?: string;
  isPromotion: boolean;
  oldPrice?: number;
}

export interface ICatalogBFFRatings {
  commentsCount?: number;
  rating?: number;
  scoresCount?: number;
}

export interface ICatalogBFFWeighted {
  isWeighted: boolean;
  minStep?: number;
  shelfLabel?: string;
  unitLabel?: string;
  unitPrice?: number;
  shelfWeight?: number;
  step?: number;
}

export interface ICatalogBFFListingGood {
  url: string; // не приходит по api - добавляется на нашей стороне
  badges?: ICatalogBFFBadge[];
  gallery: ICatalogBFFMedia[];
  id: number;
  isForAdults: boolean;
  isInFavorites?: boolean;
  isLowStock?: boolean;
  name: string;
  orders?: number;
  price: number;
  profit?: number;
  productId?: string;
  promotion: ICatalogBFFPromotion;
  quantity: number;
  ratings?: ICatalogBFFRatings;
  seoCode?: string;
  skuGroupId?: string;
  storeCode: string;
  weighted: ICatalogBFFWeighted;
}
